import { useT } from "react-polyglot-hooks"
import { sendEvent } from "scripts/GoogleAnalytics"
import * as PropTypes from "prop-types"
import styled, { css } from "styled-components"
import Link from "components/Link"
import CheckBoxField from "../CheckBoxField"

const Url = styled.a(({ theme, white }) =>
  white
    ? css`
        color: ${theme.colors.white};
        text-decoration: underline;

        &:hover {
          color: ${theme.colors.deepPink};
          text-decoration: underline;
        }
      `
    : css`
        color: ${theme.colors.deepPink};

        &:hover {
          color: ${theme.colors.mediumVioletRed};
        }
      `
)

export default function TermsAndPrivacyField({ white, ...props }) {
  const t = useT()
  const { formName } = props

  const handleTermsClick = () => {
    sendEvent("form", {
      event_category: formName,
      event_label: "terms"
    })
  }

  const handlePrivacyClick = () => {
    sendEvent("form", {
      event_category: formName,
      event_label: "privacy policy"
    })
  }

  return (
    <CheckBoxField
      {...props}
      label={
        <span>
          {t("common.form.accept_terms_and_conditions.0")}
          <Link page="terms">
            <Url target="_blank" rel="noindex noreferrer noopener" onClick={handleTermsClick} white={white}>
              {t("common.form.accept_terms_and_conditions.1")}
            </Url>
          </Link>
          {t("common.form.accept_terms_and_conditions.2")}
          <Link page="privacy">
            <Url target="_blank" rel="noindex noreferrer noopener" onClick={handlePrivacyClick} white={white}>
              {t("common.form.accept_terms_and_conditions.3")}
            </Url>
          </Link>
        </span>
      }
    />
  )
}

TermsAndPrivacyField.propTypes = {
  formName: PropTypes.string.isRequired,
  white: PropTypes.bool
}

TermsAndPrivacyField.defaultProps = {
  white: false
}
